export default __webpack_public_path__ + "static/media/icon-material-error-outline.0de8a5d3.svg";